import React, { Component } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import { Modal, Input, Button, notification } from 'antd';
import JourneySettingStepBar from 'components/journeys/JourneySettingStepBar';
import AscendForm from 'components/journeys/AscendForm';
import OTextArea from 'components/commons/OTextArea';
import { translate  } from 'react-i18next';
import MonthRangePicker from 'components/commons/MonthRangePicker';
import ONumericInput from 'components/commons/ONumericInput';

class JourneySettingModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: true,
            journey: props.journey,
            loading: true
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ journey: nextProps.journey, loading: nextProps.loading });
    }

    render() {
        const {t} = this.props;
        return (
            <Modal
            visible={this.state.visible && !this.state.loading}
            onOk={this.hideModal.bind(this)}
            onCancel={this.hideModal.bind(this)}
            className="journey-setting"
            width="50%"
            footer={null}
            >
            <JourneySettingStepBar>
                <OTextArea 
                    onUpdate={this.onUpdate.bind(this)} 
                    title={t('journey.aware.label')}
                    container={this.state.journey} 
                    fieldName='aware' 
                    label={t('journey.aware.question')}/>
                <OTextArea 
                    onUpdate={this.onUpdate.bind(this)} 
                    title={t('journey.engage.label')}
                    container={this.state.journey} 
                    fieldName='engage' 
                    label={t('journey.engage.question')}/>
                <OTextArea 
                    onUpdate={this.onUpdate.bind(this)} 
                    title={t('journey.subscribe.label')}
                    container={this.state.journey} 
                    fieldName='subscribe' 
                    label={t('journey.subscribe.question')}/>
                <OTextArea 
                    onUpdate={this.onUpdate.bind(this)} 
                    title={t('journey.convert.label')}
                    container={this.state.journey} 
                    fieldName='convert' 
                    label={t('journey.convert.question')}/>
                <OTextArea 
                    onUpdate={this.onUpdate.bind(this)} 
                    title={t('journey.excite.label')}
                    container={this.state.journey} 
                    fieldName='excite' 
                    label={t('journey.excite.question')}/>
                <AscendForm 
                    onUpdate={this.onUpdate.bind(this)} 
                    title="Ascend" 
                    container={this.state.journey} />
                <OTextArea 
                    onUpdate={this.onUpdate.bind(this)} 
                    title={t('journey.advocate.label')}
                    container={this.state.journey} 
                    fieldName='advocate' 
                    label={t('journey.advocate.question')}/>
                <Col title="Sell" xs={12}>
                    <Row>
                    <Col xs="12">
                        <OTextArea 
                            onUpdate={this.onUpdate.bind(this)} 
                            title={t('journey.sell.label')}
                            container={this.state.journey} 
                            fieldName='promote' 
                            label={t('journey.sell.question')}/>
                    </Col>
                    </Row>
                    <Row center="xs" className="step-bar-controls">
                        <Button type="primary" size="lg" onClick={() => this.done()}>{t('done')}</Button>
                    </Row>
                </Col>   
            </JourneySettingStepBar>
        </Modal>
        );
    }

    done() {
        this.state.journey.enabled = true;
        this.setState({ journey: this.state.journey });
        this.hideModal();
    }

    hideModal() {
        this.setState({ visible: false }, () => console.log("closed"));
    }

    showModal() {
        this.setState({ visible: true }, () => console.log("opened"));
    }

    onUpdate(journey) {
        if (this.props.onUpdate) {
            this.props.onUpdate(journey);
        }
    }
}

export default translate('translations')(JourneySettingModal);


// WEBPACK FOOTER //
// ./src/components/journeys/JourneySettingModal.js